import { render, staticRenderFns } from "@/components/Layout/Menu/Gestores/Acarreo/Acarreo.html?vue&type=template&id=57aac54a&scoped=true&"
import script from "@/components/Layout/Menu/Gestores/Acarreo/Acarreo.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Gestores/Acarreo/Acarreo.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Gestores/Acarreo/Acarreo.css?vue&type=style&index=0&id=57aac54a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aac54a",
  null
  
)

export default component.exports